var map = {
	"./bird-1-right.png": "9583",
	"./bird-10-right.png": "26af",
	"./bird-11-right.png": "abab",
	"./bird-12-right.png": "df90",
	"./bird-13-right.png": "62da",
	"./bird-14-right.png": "aea6",
	"./bird-2-right.png": "1064",
	"./bird-3-right.png": "a7fd",
	"./bird-4-right.png": "bfb8",
	"./bird-5-right.png": "7ff8",
	"./bird-6-right.png": "ad09",
	"./bird-7-right.png": "091f",
	"./bird-8-right.png": "9073",
	"./bird-9-right.png": "5117"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4e2e";